import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import RemoveIcon from '@mui/icons-material/Remove';
import { IconTextWrapper } from './ComparativeTable';
interface Props {
  icon: React.ElementType;
  label: string;
  coursesData?: string;
  diplomaData: string;
}
const Tr = styled('tr')(({
  theme: {
    palette
  }
}) => ({
  borderBottom: `1px solid ${palette.layout.line.divider}`
}));
const Th = styled('th')(({
  theme: {
    spacing
  }
}) => ({
  '&&': {
    justifyContent: 'flex-start',
    padding: spacing(2)
  }
}));
const Td = styled('td')(({
  theme: {
    palette
  }
}) => ({
  '&:nth-of-type(1)': {
    backgroundColor: palette.notification.neutral.background
  },
  '&:nth-of-type(2)': {
    backgroundColor: palette.content.highlight.secondLevel.background
  }
}));
const IconMobileOnlyWrapper = styled('div', {})(({
  theme: {
    breakpoints
  }
}) => ({
  [breakpoints.up('sm')]: {
    display: 'none'
  }
}));
export default function Line(t0) {
  const $ = _c(23);
  const {
    icon: Icon,
    label,
    coursesData,
    diplomaData
  } = t0;
  let t1;
  if ($[0] !== Icon) {
    t1 = <Icon />;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <Typography variant="subheadingSmall" component="h3">{label}</Typography>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <Th scope="row"><IconTextWrapper>{t1}{t2}</IconTextWrapper></Th>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== Icon || $[8] !== coursesData || $[9] !== label) {
    t4 = <Td>{coursesData ? <IconTextWrapper><IconMobileOnlyWrapper><Icon aria-label={label} aria-hidden="false" /></IconMobileOnlyWrapper><Typography variant="bodySmall">{coursesData}</Typography></IconTextWrapper> : <RemoveIcon />}</Td>;
    $[7] = Icon;
    $[8] = coursesData;
    $[9] = label;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== Icon || $[12] !== label) {
    t5 = <IconMobileOnlyWrapper><Icon aria-label={label} aria-hidden="false" /></IconMobileOnlyWrapper>;
    $[11] = Icon;
    $[12] = label;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== diplomaData) {
    t6 = <Typography variant="bodySmall">{diplomaData}</Typography>;
    $[14] = diplomaData;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <Td><IconTextWrapper>{t5}{t6}</IconTextWrapper></Td>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t3 || $[20] !== t4 || $[21] !== t7) {
    t8 = <Tr>{t3}{t4}{t7}</Tr>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}